import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  profileOpen: boolean = true;
  showCSEMenu: boolean = false;
  showLogout: boolean = false;
  menuList = [
    {
      text: 'Dashboard',
      route: 'admin/dashboard'
    },
    {
      text: 'Facility Listing',
      route: 'admin/facility-listing'
    },
    {
      text: 'CSE Section',
      route: 'admin/cse'
    },
    // {
    //   text: 'Reports'
    // },
  ];
  roleName=''
  constructor(private router: Router, private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    // setTimeout(() => {
    // }, 1000);
    if(sessionStorage.getItem('user-role')){
      const role:any= JSON.parse(sessionStorage.getItem('user-role'))
      this.roleName=role
    }
   
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const currentRoute = event.urlAfterRedirects.split('#')[0].split('?')[0];
        this.menuList.forEach((menu, index) => {
          (<HTMLInputElement>document.getElementById(index.toString())).classList.remove('clickedClasss');
        });
        // Add the active class to the corresponding menu item
        const menuItem = this.menuList.find((menu:any) => currentRoute.includes(menu.route));
        if (menuItem) {
          const id = this.menuList.indexOf(menuItem);
          (<HTMLInputElement>document.getElementById(id.toString())).classList.add('clickedClasss');
        }
      }
    });
  
  }

  ngAfterViewInit() {
    let selectId = +sessionStorage.getItem('menuSelected_id')
    if (selectId == undefined || selectId == null) {
      selectId = 0;
    }
    (<HTMLInputElement>document.getElementById(selectId.toString())).classList.add("clickedClasss");
    // console.log(
    //   (<HTMLInputElement>document.getElementById("Group_16603"))
    // );
  }

  menuClick(menu, id) {
    if (menu == 'Dashboard') {
      this.router.navigateByUrl('admin/dashboard');
      this.showCSEMenu = false;
    } else if (menu == 'Facility Listing') {
      this.router.navigateByUrl('admin/facility-listing');
      this.showCSEMenu = false;
    } else if (menu == 'CSE Section') {
      this.showCSEMenu = !this.showCSEMenu;
      (<HTMLInputElement>document.getElementById(id.toString())).classList.add("borderRadiusForCSE");
    }

    sessionStorage.setItem("isClearFilter", 'true');
    console.log(id);
    // console.log((<HTMLInputElement>document.getElementById(id.toString())));
    (<HTMLInputElement>document.getElementById(id.toString())).classList.add("clickedClasss");
    sessionStorage.setItem('menuSelected_id', id);

    for (let i = 0; i < this.menuList.length; i++) {

      if (i !== id) {
        console.log(i, id);
        (<HTMLInputElement>document.getElementById(i.toString())).classList.remove("clickedClasss");
      }
    }
  }

  showCSESEMenu(menuNumber) {
    if (menuNumber == 'menu1') {
      this.router.navigateByUrl('admin/cse-listing')
    } else if (menuNumber == 'menu2') {
      this.router.navigateByUrl('admin/cse-mapped-list')
    }

    sessionStorage.setItem("isClearFilter", 'true');
  }

  redirectToFacility() {
    this.router.navigateByUrl('admin/facility-listing')
  }
  menuIsActive(index: number): boolean {
    return index.toString() === sessionStorage.getItem('menuSelected_id');
  }
  moveToDashboard() {
    this.router.navigateByUrl('admin');
  }

  moveToLandingPage() {
    this.router.navigateByUrl('');
  }

  logoutClick() {
    sessionStorage.clear();
    this.router.navigateByUrl('dashboard');
    Swal.fire("Success", 'Logged out successfully', 'success');
  }
  avatarClick() {
    this.profileOpen = !this.profileOpen;
    this.showLogout = !this.showLogout;
  }

}
